import { Box, SpaceBetween } from '@amzn/awsui-components-react';

import { describeStationConfig } from '../constants/stationConfig';
import type { StationConfig } from '../constants/stationConfig';

interface DrishtiStationFactsProps {
    readonly config: StationConfig;
}

const DrishtiStationFacts = ({ config }: DrishtiStationFactsProps) => {
    return (
        <SpaceBetween size="xxs">
            {describeStationConfig(config).map(({ label, value }) => (
                <div key={label}>
                    <Box variant="span" fontWeight="bold">
                        {label}:
                    </Box>{' '}
                    <Box variant="span">{value}</Box>
                </div>
            ))}
        </SpaceBetween>
    );
};

export default DrishtiStationFacts;
